module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdc-layout-grid__inner"
  }, [_c('div', {
    staticClass: "mdc-layout-grid__cell mdc-layout-grid__cell--span-12"
  }, [_c('p', {
    staticClass: "mdc-typography--title"
  }, [_vm._v("Hi!")]), _vm._v(" "), _c('p', {
    staticClass: "mdc-typography--body1"
  }, [_vm._v("\n      I'm Ajay Addepalle, passionate about software technology, video games. Have a look around my website if any of\n      these topics interest you.\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "mdc-typography--caption"
  }, [_vm._v("\n        For correspondence, head over to the\n        "), _c('router-link', {
    staticClass: "mdc-typography--caption",
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")]), _vm._v("\n        page.\n      ")], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33658cc4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 68
// module chunks = 1